import type { GDSStyleObject } from '@leagueplatform/genesis-core';
import type { StatusReportTableColumnKey } from '../status-report-table-row.types';

export const getStatusReportCellCss = (
  columnKey: StatusReportTableColumnKey,
): GDSStyleObject => {
  if (columnKey === 'status') {
    return {
      minWidth: '8.5rem',
      paddingBlock: '$half',
      paddingInlineStart: '$threeQuarters',
      paddingInlineEnd: '$two',
      verticalAlign: 'top',
      whiteSpace: 'nowrap',
    };
  }

  if (columnKey === 'linkableText') {
    return {
      minWidth: '22rem',
      paddingBlock: '$half',
      paddingInlineStart: '$none',
      paddingInlineEnd: '$one',
      verticalAlign: 'top',
      whiteSpace: 'nowrap',
    };
  }

  return {
    paddingBlock: '$half',
    paddingInlineStart: '$none',
    paddingInlineEnd: '$threeQuarters',
    verticalAlign: 'top',
    width: '100%',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
  };
};
